module.exports = __webpack_public_path__ + "media/contact.56eb1bf2.mp4";